export const uiMultipleTexts = {
  dropFilesHere: 'Slipp filene her ...',
  selectOrDragFiles: 'Dra filer hit for å laste dem opp eller ',
  chooseFiles: 'velg filer',
}
export const uiSingleTexts: typeof uiMultipleTexts = {
  dropFilesHere: 'Slipp filen her ...',
  selectOrDragFiles: 'Dra en fil for å laste den opp eller ',
  chooseFiles: 'velg en fil',
}
export const uiThumbnailMultipleTexts: typeof uiMultipleTexts = {
  dropFilesHere: 'Slipp bildene her ...',
  selectOrDragFiles: 'Dra bilder hit for å laste dem opp eller ',
  chooseFiles: 'velg fra kamerarull',
}
export const uiThumbnailSingleTexts: typeof uiMultipleTexts = {
  dropFilesHere: 'Slipp bildet her ...',
  selectOrDragFiles: 'Dra et bilde for å laste det opp eller ',
  chooseFiles: 'velg fra kamerarull',
}
